import * as React from 'react';

import { PropertyLegalDisclaimer } from '@shared-ui/lodging-property-offers';

import { SharedUiWrapperProps, withSharedUiPropertyOffers } from './shared-ui-property-offers';
import { SimpleLazyLoadWrapper } from 'components/common/lazy/simple-lazy-load-wrapper';

const PropertyLegalDisclaimerWrapper: React.FC<SharedUiWrapperProps> = React.memo(({ inputs }) => (
  <SimpleLazyLoadWrapper>
    <div data-stid="property-legal-disclaimer">
      <PropertyLegalDisclaimer inputs={inputs} skipSsr={true} />
    </div>
  </SimpleLazyLoadWrapper>
));

PropertyLegalDisclaimerWrapper.displayName = 'PropertyLegalDisclaimerWrapper';
export const SharedUiPropertyLegalDisclaimerWrapper = withSharedUiPropertyOffers(PropertyLegalDisclaimerWrapper);
